export const yearandgrade = {
  levels: [
    {
      value: "",
      name: "--None--",
    },
    {
      value: "Pre-Nursery",
      name: "Pre-Nursery",
    },
    {
      value: "Nursery / FS1",
      name: "Nursery / FS1",
    },
    {
      value: "FS2/KG1",
      name: "FS2/KG1",
    },
    {
      value: "Year 1 / KG2",
      name: "Year 1 / KG2",
    },
    {
      value: "Year 2 / Grade 1",
      name: "Year 2 / Grade 1",
    },
    {
      value: "Year 3 / Grade 2",
      name: "Year 3 / Grade 2",
    },
    {
      value: "Year 4 / Grade 3",
      name: "Year 4 / Grade 3",
    },
    {
      value: "Year 5 / Grade 4",
      name: "Year 5 / Grade 4",
    },
    {
      value: "Year 6 / Grade 5",
      name: "Year 6 / Grade 5",
    },
    {
      value: "Year 7 / Grade 6",
      name: "Year 7 / Grade 6",
    },
    {
      value: "Year 8 / Grade 7",
      name: "Year 8 / Grade 7",
    },
    {
      value: "Year 9 / Grade 8",
      name: "Year 9 / Grade 8",
    },
    {
      value: "Year 10 / Grade 9",
      name: "Year 10 / Grade 9",
    },
    {
      value: "Year 11 / Grade 10",
      name: "Year 11 / Grade 10",
    },
    {
      value: "Year 12 / Grade 11",
      name: "Year 12 / Grade 11",
    },
    {
      value: "Year 13 / Grade 12",
      name: "Year 13 / Grade 12",
    },
  ],
};
